import {
	Component,
	Input,
	forwardRef,
	Output,
	EventEmitter,
	OnDestroy,
	SimpleChanges,
	OnChanges,
	AfterViewInit,
	OnInit
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import { FormControlBase } from "../shared/classes/form-control-base";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: "rbc-select",
	templateUrl: "./select.component.html",
	styles: [],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => SelectComponent)
		}
	]
})
export class SelectComponent implements ControlValueAccessor, OnDestroy {
	@Input() disabled: string | boolean;
	@Input() helpText: string;
	@Input() id: string;
	@Input() label: string;
	@Input() labelSrOnly: string;
	@Input() name: string;
	@Input() ariaLabel: string;
	@Input() status: string;
	@Input() statusType: string;
	@Input() wrapperClass;
	@Input() options: Array<any>;
	protected _value = "";

	@Input() set value(val){
		this._value = val;
	};
	get value(){
		return this._value;
	}
	@Input() size: "large" | "medium" | "small" = "medium";
	@Input() sizeWidth: string;

	@Input() ariaDescribedby;

	@Output() valueChange = new EventEmitter();

	current;

	get describedbyGen() {
		if (this.helpText || this.ariaDescribedby) {
			const descriptors = {
				[`${this.id}HelpText`]: this.helpText,
				[this.ariaDescribedby]: this.ariaDescribedby
			};
			return Object.keys(descriptors)
				.filter(key => descriptors[key])
				.join(" ");
		} else {
			return null;
		}
	}

	get classGen() {
		return {
			["rbc-paginator-select-control"]: this.wrapperClass,
			[`rbc-select-${this.size}`]: this.size,
			[`rbc-select-width-${this.sizeWidth}`]: this.sizeWidth,
			disabled: this.disabled && this.disabled !== "false"
		};
	}

	// get selected() {
	// 	this.options.forEach((x) => {
	// 		if (x.selected) {
	// 			this.current = x;
	// 		}
	// 	});
	// 	return this.current ? this.current : null;
	// }
	// set selected(val) {
	// 	this.current = val;
	// }

	get optionsGen() {
		if (this.options) {
			return this.options;
		} else {
			return [];
		}
	}
	set optionsGen(val) {
		this.options = val;
	}
	constructor(private idService: IdService) {
		this.id = idService.generate();
	}


	writeValue(obj: any): void {
		this.value = obj
	}
	/**
	 * Handles the change event from the `select`.
	 * Sends events to the change handler and emits a `selected` event.
	 */
	onChange(event) {
		this.value = event.target.value;
		this.onChangeHandler(event.target.value);
		this.valueChange.emit(event.target.value);
	}

	/**
	 * placeholder declarations. Replaced by the functions provided to `registerOnChange` and `registerOnTouched`
	 */
	protected onChangeHandler = (_: any) => { };
	protected onTouchedHandler = () => { };

	registerOnChange(fn: any): void {
		this.onChangeHandler = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouchedHandler = fn;
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// Handlers
	selectChangeHandler(selectEvent) {
		this.onChange(selectEvent);

		this.value = selectEvent
		this.processValue();

		// this.options = this.getOptionsUpdated(this.value);
		// this.options.find(o => o.value === this.value);
	}

	// // Handlers
	// onClick(selectEvent) {
	// 	this.modelInput.emit(selectEvent);
	// 	this.value = selectEvent
	// }
	processValue() {
		if (this.options) {
			const option = this.options.find(o => o.value === this.value);

			if (option) {
				this.value = option.value;
			} else {
				this.value = null;
			}
		}
	}
	// Methods
	// update options to reflect state correctly
	getOptionsUpdated(selectedValue) {
		return this.options.map(opt => {
			opt.selected = !!(opt.value === selectedValue);
			return opt;
		});
	}
}
